// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/notification.eot?s3g3t9", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/notification.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/notification.woff?s3g3t9", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/notification.ttf?s3g3t9", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fonts/notification.svg?s3g3t9", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefixs3g3t9" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#notification" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: Notification;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: 400;
  font-style: normal;
}
.notification-container {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999999;
  width: 320px;
  padding: 0 15px;
  max-height: calc(100% - 30px);
  overflow-x: hidden;
  overflow-y: auto;
}

.notification, .notification-container {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.notification {
  padding: 15px 15px 15px 58px;
  border-radius: 2px;
  color: #fff;
  background-color: #ccc;
  -webkit-box-shadow: 0 0 12px #999;
  box-shadow: 0 0 12px #999;
  cursor: pointer;
  font-size: 1em;
  line-height: 1.2em;
  position: relative;
  opacity: 0.9;
  margin-top: 15px;
}

.notification .title {
  font-size: 1em;
  line-height: 1.2em;
  font-weight: 700;
  margin: 0 0 5px;
}

.notification:focus, .notification:hover {
  opacity: 1;
}

.notification-enter {
  visibility: hidden;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

.notification-enter.notification-enter-active {
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
}

.notification-enter.notification-enter-active, .notification-leave {
  visibility: visible;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.notification-leave.notification-leave-active {
  visibility: hidden;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
}

.notification:before {
  position: absolute;
  top: 50%;
  left: 15px;
  margin-top: -14px;
  display: block;
  font-family: Notification;
  width: 28px;
  height: 28px;
  font-size: 28px;
  text-align: center;
  line-height: 28px;
}

.notification-info {
  background-color: #2f96b4;
}

.notification-info:before {
  content: "\\f05a";
}

.notification-success {
  background-color: #51a351;
}

.notification-success:before {
  content: "\\f058";
}

.notification-warning {
  background-color: #f89406;
}

.notification-warning:before {
  content: "\\f06a";
}

.notification-error {
  background-color: #bd362f;
}

.notification-error:before {
  content: "\\f057";
}`, "",{"version":3,"sources":["webpack://./assets/src/css/react-notification/react-notifications.css"],"names":[],"mappings":"AACA;EACI,yBAAA;EACA,4CAAA;EACA,mPAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;AAGA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,8BAAA;EACA,sBAAA;AADJ;;AAIA;EACI,4BAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AADJ;;AAIA;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AADJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,kBAAA;EACA,0CAAA;EACA,kCAAA;AADJ;;AAIA;EACI,4BAAA;EACA,oBAAA;AADJ;;AAIA;EACI,mBAAA;EACA,gCAAA;EACA,wBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,0CAAA;EACA,kCAAA;EACA,4BAAA;EACA,oBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ","sourcesContent":["@charset \"UTF-8\";\n@font-face {\n    font-family: Notification;\n    src: url(fonts/notification.eot?s3g3t9);\n    src: url(fonts/notification.eot?#iefixs3g3t9) format(\"embedded-opentype\"), url(fonts/notification.woff?s3g3t9) format(\"woff\"), url(fonts/notification.ttf?s3g3t9) format(\"truetype\"), url(fonts/notification.svg?s3g3t9#notification) format(\"svg\");\n    font-weight: 400;\n    font-style: normal\n}\n\n.notification-container {\n    position: fixed;\n    top: 0;\n    right: 0;\n    z-index: 999999;\n    width: 320px;\n    padding: 0 15px;\n    max-height: calc(100% - 30px);\n    overflow-x: hidden;\n    overflow-y: auto\n}\n\n.notification, .notification-container {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box\n}\n\n.notification {\n    padding: 15px 15px 15px 58px;\n    border-radius: 2px;\n    color: #fff;\n    background-color: #ccc;\n    -webkit-box-shadow: 0 0 12px #999;\n    box-shadow: 0 0 12px #999;\n    cursor: pointer;\n    font-size: 1em;\n    line-height: 1.2em;\n    position: relative;\n    opacity: .9;\n    margin-top: 15px\n}\n\n.notification .title {\n    font-size: 1em;\n    line-height: 1.2em;\n    font-weight: 700;\n    margin: 0 0 5px\n}\n\n.notification:focus, .notification:hover {\n    opacity: 1\n}\n\n.notification-enter {\n    visibility: hidden;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0)\n}\n\n.notification-enter.notification-enter-active {\n    -webkit-transition: all .4s;\n    transition: all .4s\n}\n\n.notification-enter.notification-enter-active, .notification-leave {\n    visibility: visible;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0)\n}\n\n.notification-leave.notification-leave-active {\n    visibility: hidden;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n    -webkit-transition: all .4s;\n    transition: all .4s\n}\n\n.notification:before {\n    position: absolute;\n    top: 50%;\n    left: 15px;\n    margin-top: -14px;\n    display: block;\n    font-family: Notification;\n    width: 28px;\n    height: 28px;\n    font-size: 28px;\n    text-align: center;\n    line-height: 28px\n}\n\n.notification-info {\n    background-color: #2f96b4\n}\n\n.notification-info:before {\n    content: \"\"\n}\n\n.notification-success {\n    background-color: #51a351\n}\n\n.notification-success:before {\n    content: \"\"\n}\n\n.notification-warning {\n    background-color: #f89406\n}\n\n.notification-warning:before {\n    content: \"\"\n}\n\n.notification-error {\n    background-color: #bd362f\n}\n\n.notification-error:before {\n    content: \"\"\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
